import { z } from "zod";

// Body of PATCH /api/settings/integrations/hubspot/linking. Mirrors the
// inline `updateLinkingSchema` from /app/admin/settings/integrations/
// _actions.ts:19-23. Vendor ops edit attribution_name + enabled per
// linking row (the rows are seeded; create/destroy is deferred to Session
// 10's Configure wizard).
export const hubspotLinkingUpdateSchema = z.object({
  id: z.string().uuid(),
  attribution_name: z.string().trim().min(1).max(120),
  enabled: z.boolean(),
});

export type HubspotLinkingUpdateInput = z.infer<typeof hubspotLinkingUpdateSchema>;
